var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{on:{"click":_vm.toggleLayout}},[_c('feather-icon',{attrs:{"size":"21","icon":_vm.icon[_vm.layoutType]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }